import React from 'react';
import User from 'helper/currentUser';
import Header from '../Header';
import { MainWrapper, InnerWrapper, CenterWrapper } from '../../styles';

const loginPagesHashes = ['/login', '/login-redirect'];

const urlIsOfLoginPages = (hash) => {
  let includes = false;
  const urlPath = hash.slice(1).split('?')[0];
  loginPagesHashes.forEach((path) => {
    if (urlPath === path) {
      includes = true;
    }
  });
  return includes;
};

const LoginWrapper = ({ children }) => {
  const user = new User();

  if (urlIsOfLoginPages(window.location.hash) && user.aToken() && user.id() && user.companyId()) {
    window.location.href = '/#/learner';
    return true;
  }
  return (
    <MainWrapper>
      <Header />
      <InnerWrapper>
        <CenterWrapper>{children}</CenterWrapper>
      </InnerWrapper>
    </MainWrapper>
  );
};

export default LoginWrapper;
